"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    min-width:200px;\n    max-height:34px;\n    .search-bar-filter {\n        display: flex;\n        align-items: center;\n        border: 1px solid #f0f0f0;\n        padding-left: 10px;\n  \n        img {\n          width: 15px;\n          height: 15px;\n        }\n  \n        input {\n          background-color: transparent;\n          padding: 10px 10px;\n          outline: none;\n          border: none;\n        }\n      }\n\n      img.icon{\n        width: 15px;\n          height: 15px;\n      }\n\n      .modal-save .contentModal {\n        max-width:200px;\n      }\n"])));

exports.Container = Container;